import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CloseIcon from '@mui/icons-material/Close';

interface IDateSelector {
  openDate: boolean;
  setOpenDate: any;
  handleDateChange: any;
  state: any;
  submit: any;
  setSubmit: any;
}

const datePickerSx = {
  flex: 1,
  '& .MuiInputBase-root': {
    height: '44px',
    borderRadius: '8px',
    background: 'var(--bg-colors)',
    border: '1px solid var(--border-color)',
    color: 'var(--text-primary-color)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 500,
  },
  '& input': {
    color: 'var(--text-primary-color)',
    fontSize: '14px',
    fontWeight: 500,
  },
  '& input::placeholder': {
    color: 'var(--text-secondary)',
    opacity: 1,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .MuiSvgIcon-root': {
    color: 'var(--text-secondary)',
  },
};

const DateSelector: React.FC<IDateSelector> = ({
  state,
  handleDateChange,
  setOpenDate,
  submit,
  setSubmit,
}) => {
  return (
    <div
      className='modal-cont'
      style={{
        width: '480px',
        maxWidth: '90vw',
        padding: 0,
        /* Adjusted to use your explicit modal canvas background color tokens */
        backgroundColor: 'var(--bg-modals, var(--bg-colors))',
      }}
    >
      {/* Header */}
      <div
        className='modal-header-cont-temp'
        style={{
          padding: '24px',
          borderBottom: '1px solid var(--border-color)',
          width: '100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            alignItems: 'flex-start',
          }}
        >
          <div className='modal-header-cont-text'>
            <h1
              className='modal-header-cont-text-h1'
              style={{ fontSize: '20px', marginBottom: '4px' }}
            >
              Filter by date
            </h1>
            <p className='modal-header-cont-text-p' style={{ margin: 0 }}>
              Select a single date or date range.
            </p>
          </div>
          <div
            className='module-header-btn-close'
            onClick={() => setOpenDate(false)}
            style={{ cursor: 'pointer', color: 'var(--text-secondary)' }}
          >
            <CloseIcon />
          </div>
        </div>
      </div>

      {/* Body */}
      <div
        className='modal-body'
        style={{
          padding: '24px',
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        <label
          style={{
            color: 'var(--text-primary-color)',
            fontSize: '14px',
            fontWeight: 500,
          }}
        >
          Date Range
        </label>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            width: '100%',
          }}
        >
          <DatePicker<Date>
            value={
              state.date && state.date !== '' ? new Date(state.date) : null
            }
            onChange={(newValue: any) =>
              handleDateChange(
                newValue && newValue !== '' ? new Date(newValue) : null,
                state.endDate && state.endDate !== '' ? state.endDate : null,
              )
            }
            shouldDisableDate={(date: any) => date > new Date()}
            slotProps={{ actionBar: { actions: ['clear'] } }}
            sx={datePickerSx}
          />
          <span style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>
            –
          </span>
          <DatePicker<Date>
            value={state.endDate ? new Date(state.endDate) : null}
            onChange={(newValue: any) =>
              handleDateChange(
                state.date && state.date !== '' ? state.date : null,
                newValue && newValue !== '' ? new Date(newValue) : null,
              )
            }
            shouldDisableDate={(date: any) => date > new Date()}
            slotProps={{ actionBar: { actions: ['clear'] } }}
            sx={datePickerSx}
          />
        </div>
      </div>

      {/* Footer */}
      <div
        style={{
          padding: '24px',
          borderTop: '1px solid var(--border-color)',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          gap: '12px',
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        <button
          className='btn-outline'
          onClick={() => setOpenDate(false)}
          style={{ margin: 0, width: 'auto' }}
        >
          Cancel
        </button>
        <button
          className='btn-primary'
          onClick={() => {
            setSubmit({
              trigger: !submit.trigger,
              reason: 'apply',
            });
            setOpenDate(false);
          }}
          style={{ margin: 0, width: 'auto' }}
        >
          Apply
        </button>
      </div>
    </div>
  );
};

export default DateSelector;
